export default "__VITE_ASSET__DESAPn63__"